<div class="error-wrap">
    <img src="assets/svg/Group.png" alt="" class="error-img">
    <div class="error-base">
        <div class="error-head">Connection Lost!</div>
        <div class="error-msg">Oops! Looks like your connection got lost. Please check your network connectivity.</div>
    </div>
</div>
